import { Box, Chip, Grid, MenuItem, Typography } from "@mui/material";
import { CustomEvent } from "schemas/functions";

import StyledSelect from "components/Styled/Select";
import TemplateEditButton from "components/TemplateEditButton";
import { Template } from "features/Influencer/ContactList/schema";

import styles from "./styles";

interface Props {
  templates: Template[];
  handleChange: (e: CustomEvent, index: number) => void;
  filteredOutreachTemplates: Template[];
  templateFromEmailSettings?: number[];
  hideEditTemplateButton?: boolean;
  addNewOption?: () => void;
  templatesError?: {
    idx: number;
    message: string;
  } | null;
  nicheId?: number;
}

const OutreachSelect = ({
  templates,
  handleChange,
  filteredOutreachTemplates,
  templateFromEmailSettings,
  hideEditTemplateButton = false,
  addNewOption = undefined,
  templatesError = null,
  nicheId,
}: Props) => {
  return (
    <Grid item xs container gap={1} alignItems={"center"}>
      <Grid item xs>
        <StyledSelect
          value={templates[0]?.id}
          onChange={(e: CustomEvent) => handleChange(e, 0)}
          defaultValue={templates[0]?.id}
          fullWidth
        >
          {!!addNewOption && (
            <MenuItem onClick={addNewOption}>
              <Box sx={styles.createButton}>Create New</Box>
            </MenuItem>
          )}

          {filteredOutreachTemplates?.map((template) => (
            <MenuItem key={template.id} value={template.id}>
              <Box
                display="flex"
                gap={1}
                flexWrap="wrap"
                sx={styles.templateName}
              >
                <Typography noWrap sx={{ maxWidth: 225 }}>
                  {template.name}
                </Typography>
                {template.id &&
                  templateFromEmailSettings?.includes(template.id) && (
                    <Chip
                      label="Last Used"
                      size="small"
                      sx={{
                        ml: 1,
                        fontSize: 10,
                        backgroundColor: "primary.light",
                      }}
                    />
                  )}
              </Box>
            </MenuItem>
          ))}
        </StyledSelect>
      </Grid>

      {templates[0]?.id && !hideEditTemplateButton && (
        <Grid item xs="auto">
          <TemplateEditButton templateId={templates[0].id} nicheId={nicheId} />
        </Grid>
      )}

      {templatesError && templatesError.idx === 0 && (
        <Grid item xs={12}>
          <Typography sx={{ mt: 0.75, fontSize: 13, color: "warning.main" }}>
            <Box component="i" className="fa-regular fa-warning" />{" "}
            {templatesError.message}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default OutreachSelect;
